module.exports = __webpack_public_path__ + "img/15.fe9f337e.jpg";